import * as React from 'react';
import { withInjectedRootStore, RootStore } from '../../providers';
import { ColorTheme } from '../../types';

export interface GlobalStylesProps {
  rootStore: RootStore;
}

function convertHex(hex, opacity) {
  hex = hex.replace('#', '');
  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);
  return `rgba(${r},${g},${b},${opacity / 100})`;
}

function generateInlineClasses(theme: ColorTheme): string {
  return `.default-colors {
    color: ${theme.mainColor} !important;
    background-color: #FFF !important;
  }
  .colors {
    color: ${theme.mainColor} !important;
  }
  .secondary-colors {
    color: ${theme.secondaryColor} !important;
  }
  .white-colors {
    color: #FFF !important;
  }
  .default-colors-hover:hover {
    color: #FFF !important;
    background-color: ${theme.secondaryColor}  !important;
  }
  .color-hover:hover {
    color: ${theme.mainColor} !important;
  }
  .bg-colors {
    background-color: ${theme.mainColor} !important;
  }
  .bg-colors-third {
    background-color:${theme.thirdColor} !important;
  }
  .bg-colors-hover:hover {
    background-color: ${theme.secondaryColor} !important;
  }
  .bg-colors-after:after {
    background-color: ${theme.mainColor} !important;
  }
  .border-color {
    border-color: ${theme.mainColor} !important;
  }
  .box-shadow {
    box-shadow: 0px 0px 0px 2px ${
      theme.mainColor
    }, 0px 7px 25px 0px rgba(0, 0, 0, 0.1);
  }
  .box-shadow-thin {
    box-shadow: 0px 0px 0px 1px ${convertHex(
      theme.mainColor,
      60,
    )}, 0px 7px 25px 0px rgba(0, 0, 0, 0);
  }
  .box-shadow-thin:hover {
    box-shadow: 0px 0px 0px 1px ${convertHex(
      theme.mainColor,
      100,
    )}, 0px 7px 25px 0px rgba(0, 0, 0, 0);
  }
  .border-color-after:after {
      border-top: 1px solid ${theme.mainColor} !important;
      border-right: 1px solid ${theme.mainColor} !important;
  }
  .background-color-product-hat-mobile {
     background: ${convertHex(theme.mainColor, 12)};
  }
  .limited-time-offering-tooltip-mobile {
    background: ${convertHex(theme.mainColor, 8)};
  }
  .tooltip-list {
    padding: 0 15px;
  }


  `;
}

const GlobalStylesComp: React.FunctionComponent<GlobalStylesProps> = ({
  rootStore,
}) => {
  const inlineClasses = generateInlineClasses(
    rootStore.appStore.appContext.theme,
  );
  return (
    <style
      dangerouslySetInnerHTML={{
        __html: inlineClasses,
      }}
    />
  );
};

export const GlobalStyles = withInjectedRootStore(GlobalStylesComp);
